import { useState, useCallback } from 'react';

const INITIAL_FORM_DATA = { name: '', address: '' };

export function useRestaurantForm(initialData = INITIAL_FORM_DATA) {
    const [formData, setFormData] = useState(initialData);
    const [errors, setErrors] = useState({});

    const handleInputChange = useCallback((e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));

        setErrors((prev) => {
            if (!prev[name]) return prev;
            const next = { ...prev };
            delete next[name];
            return next;
        });
    }, []);

    const validateForm = useCallback(() => {
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = 'Restaurant name is required';
        }

        if (!formData.address.trim()) {
            newErrors.address = 'Address is required';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }, [formData.name, formData.address]);

    const resetForm = useCallback(() => {
        setFormData(INITIAL_FORM_DATA);
        setErrors({});
    }, []);

    const getTrimmedFormData = useCallback(() => ({
        name: formData.name.trim(),
        address: formData.address.trim(),
    }), [formData.name, formData.address]);

    return {
        formData,
        errors,
        handleInputChange,
        validateForm,
        resetForm,
        getTrimmedFormData,
    };
}
